import React from 'react';
import { useTranslation } from 'react-i18next';

import cameraManager from '../../../../../viewer/camera-manager';
import { ElementObj } from '../../../../../viewer/elements/element-obj';
import { Icon } from '../../../icon/icon';

export const FocusIcon = (props: { focusedAssetId?: string; asset: ElementObj }) => {
  const { t } = useTranslation();

  return (
    <Icon
      fixedWidth={true}
      icon={props.focusedAssetId === props.asset.uuid ? ['fas', 'square'] : ['fal', 'square']}
      mouseDownStyle={{ opacity: 0.5 }}
      title={t('focus', { ns: 'common' })}
      onClick={() => cameraManager().getActiveController()?.focusOnAsset(props.asset)}
      onHoverStyle={{ icon: ['fad', 'square'] }}
    />
  );
};
